import imGcal from '@/icons/gcal.svg';
import { Image } from '@chakra-ui/react';

export interface IimgCalendarProviderProps {
	isHidden?: boolean;
	provider: 'GOOGLE' | 'MICROSOFT';
	size: string;
}

export default function ImgCalendarProvider(props: IimgCalendarProviderProps) {
	if (props.isHidden) {
		return null;
	}

	switch (props.provider) {
		case 'GOOGLE':
			return <Image display="inline" width={props.size} height={props.size} src={imGcal} alt="" />;
		case 'MICROSOFT':
			return (
				<Image
					display="inline"
					width={props.size}
					height={props.size}
					src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Outlook.com_icon_%282012-2019%29.svg/1200px-Outlook.com_icon_%282012-2019%29.svg.png"
					alt=""
				/>
			);
	}
}
